module.exports = __webpack_public_path__ + "img/project-10.ad252c3b.jpg";